import { FormikProps } from 'formik';

import { recordBracketCellChildAdd, recordBracketCellChildAddDecider } from '../../../../../utils/bracketCellPendingDeletes.util';
import { BracketCellGroup } from '../../../../../utils/groupMatchesByBracketCell';
import { PlayValues } from '../PlayTag/PlayTag';

export function useBracketCellMutations(
  group: BracketCellGroup,
  formikArg: FormikProps<PlayValues>,
  tiebreakerLabel: string,
) {
  const handleAddCategoryMatch = (selectedCategoryId: number) => {
    recordBracketCellChildAdd(
      formikArg,
      group,
      selectedCategoryId,
      formikArg.values.tournamentCategories,
    );
  };

  const handleAddDeciderMatch = () => {
    recordBracketCellChildAddDecider(formikArg, group, tiebreakerLabel);
  };

  return { handleAddCategoryMatch, handleAddDeciderMatch };
}
